module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_91-f2354e4b4a0fbe7ba10291c9af4b8a93.png";